import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Button from '../components/ui/Button';

const { FiMail, FiStar, FiFilter, FiMapPin, FiLayout, FiActivity } = FiIcons;

const Features = () => {
  const features = [
    {
      icon: FiMail,
      title: "Automated Review Requests",
      description: "Set it and forget it. Automatically send SMS or email review invitations to your customers right after they make a purchase or visit your business."
    },
    {
      icon: FiStar,
      title: "Google Review Generation",
      description: "Direct happy customers straight to your Google Business Profile. Increase your average rating and climb to the top of local search rankings."
    },
    {
      icon: FiFilter,
      title: "Smart Feedback Filtering",
      description: "Protect your reputation. Our smart routing intercepts unhappy customers and directs them to a private feedback form before they leave a public negative review."
    },
    {
      icon: FiMapPin,
      title: "Multi-Location Support",
      description: "Manage one location or one hundred. Perfect for franchises and Unlimited users, providing a unified dashboard to monitor performance across all branches."
    },
    {
      icon: FiLayout,
      title: "White-Label Dashboard",
      description: "Unlimited plan users can brand the entire platform as their own. Add your logo, custom domain, and brand colors to provide a premium service to your clients."
    },
    {
      icon: FiActivity,
      title: "Review Monitoring",
      description: "Stay on top of what people are saying. Track and respond to reviews across Google, Facebook, Yelp, and other major platforms from one central inbox."
    }
  ];

  return (
    <div className="py-20 bg-white">
      <div className="container px-4 mx-auto max-w-7xl">
        <div className="max-w-3xl mx-auto mb-20 text-center">
          <h1 className="mb-6 text-4xl font-bold md:text-5xl text-primary">Everything you need to build trust.</h1>
          <p className="text-xl text-slate-600">Powerful features designed to automate your reputation management and drive more sales.</p>
        </div>

        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
          {features.map((feature, idx) => (
            <motion.div 
              key={idx}
              whileHover={{ y: -5 }}
              className="p-8 transition-shadow border bg-slate-50 rounded-2xl border-slate-100 hover:shadow-soft"
            >
              <div className="flex items-center justify-center w-12 h-12 mb-6 rounded-lg bg-secondary/10 text-secondary">
                <SafeIcon icon={feature.icon} className="w-6 h-6" />
              </div>
              <h3 className="mb-3 text-xl font-bold text-primary">{feature.title}</h3>
              <p className="leading-relaxed text-slate-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <div className="p-12 mt-24 text-center rounded-3xl bg-primary text-white">
          <h2 className="mb-6 text-3xl font-bold">Experience these features in action</h2>
          <p className="mb-8 text-lg text-slate-300">Start your 14-day free trial today. Full access to all features.</p>
          <Button to="/free-trial" variant="accent" size="lg">Start Free Trial Now</Button>
        </div>
      </div>
    </div>
  );
};

export default Features;